angular.module('app.directives.schedule').directive('fbLiveSimulcastSettings', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '=',
    },
    template: require('./fb-live-simulcast-settings.html'),
    controller: function ($scope, $filter) {
      'ngInject';

      function renderSelectizeOption(wrapperCssClass, dateFilter) {
        return function (item, escape) {
          let html = `<div class="${wrapperCssClass}" style="vertical-align: middle;">`;
          if (item.cover) {
            html += `<div style="display: inline-flex; float: left; width: 32px; height: 18px; margin-right: 6px; background-size: cover; background-repeat: no-repeat; background-position: center; background-image: url('${item.cover.source}');"></div>`;
          }
          if (item.start_time) {
            html += `<div class="date-range" style="display: inline-flex; float: right; margin-left: 3px;">(${dateFilter(
              item.start_time
            )})</div>`;
          }
          html += `<div class="overflow-ellipse">${item.name}</div></div>`;
          return html;
        };
      }

      const selectizeConfigBase = {
        valueField: 'id',
        labelField: 'name',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option', $filter('date')),
          item: renderSelectizeOption('source-chooser--selected', $filter('date')),
        },
      };
      $scope.pagesSelectizeConfig = angular.extend(
        { placeholder: 'Select Page...' },
        selectizeConfigBase
      );
      $scope.groupsSelectizeConfig = angular.extend(
        { placeholder: 'Select Group...' },
        selectizeConfigBase
      );
      $scope.eventsSelectizeConfig = angular.extend(
        { placeholder: 'Select Event...' },
        selectizeConfigBase
      );
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/fb-live-simulcast-settings.js